<template>
  <div>
    <div class="panel">
      <div class="filter">
        <el-form
          :inline="true"
          @submit.native.prevent
          :model="filter"
          ref="filterForm"
          label-position="right"
          label-width="80px"
          class="search-form oneline"
          size="small"
        >
          <el-form-item label="关键字" prop="query">
            <el-input
              v-model="filter.query"
              placeholder="名称"
              @keyup.enter.native="
                filter.page = 1
                getData()
              "
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="
                filter.page = 1
                getData()
              "
              >筛选</el-button
            >
            <el-button size="small" @click="reset()">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="panel">
      <el-button
        icon="el-icon-plus"
        type="primary"
        size="small"
        @click="formerVisible = true"
        v-permission="
          category == 1 ? Auth.itemTemplateNew : Auth.instrumentItemTemplateNew
        "
        >添加配件分类</el-button
      >
      <item-table
        :items="items.list"
        :category="category"
        v-loading="loading"
      ></item-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        @current-change="getData"
        layout="total, prev, pager, next"
        :total="items.count"
      ></el-pagination>
    </div>
    <item-former
      :model="model"
      :show.sync="formerVisible"
      @created="createdCallback"
    ></item-former>
  </div>
</template>

<script>
import { itemTemplateList } from '@/service/getData'
import ItemTable from './table'
import ItemFormer from './former'

export default {
  props: {
    category: {
      type: Number,
      default: 0,
    },
  },
  components: {
    ItemTable,
    ItemFormer,
  },
  data() {
    return {
      loading: false,
      filter: { query: '', page: 1, size: 10 },
      model: {
        name: '',
        category: this.category,
        type: 1,
        custom_params: [],
        warning_current_day: 0,
        warning_condition_type: 1,
        warning_current_hour: 0,
      },
      formerVisible: false,
      items: {
        list: [],
        count: 0,
      },
    }
  },
  created() {
    if (this.$route.query.filter) {
      this.filter = JSON.parse(this.$route.query.filter)
    }
    this.getData()
  },
  methods: {
    reset() {
      this.$refs['filterForm'].resetFields()
      this.filter.page = 1
      this.getData()
    },
    async getData() {
      this.$router.replace({
        query: { filter: JSON.stringify(this.filter) },
      })

      let data = {
        page: this.filter.page - 1,
        size: this.filter.size,
        query: this.filter.query,
        category: this.category,
      }
      this.loading = true
      let res = await itemTemplateList(data)
      if (res.status != 0) return false
      this.items = res.data
      this.loading = false
    },
    async loadData(page) {
      this.page = page
      this.getData()
    },
    createdCallback(item) {
      this.items.list.unshift(item)
    },
  },
}
</script>